<script lang="ts">
  import type { DropdownPoints } from './dropdown.types';
  import DropdownPoint from './DropdownPoint.svelte';

  const { points }: { points: DropdownPoints } = $props();
</script>

{#each Object.entries(points) as [id, point] (id)}
  <DropdownPoint icon={point.icon} href={point.href} active={point.active} alarm={point.alarm} count={point.count} separated={point.separated} onselect={point.onselect}>
    {point.label}
  </DropdownPoint>
{/each}
